module.exports = __webpack_public_path__ + "img/face-nose-steam.ccb37537.svg";